import React, { useEffect, useState } from 'react';

const ShinyText = ({ text }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);

  useEffect(() => {
    let interval, timeout;

    if (!isPaused) {
      interval = setInterval(() => {
        setCurrentIndex(prevIndex => {
          const newIndex = (prevIndex + 1) % text.length;
          // Check if we've completed one full cycle
          if (newIndex === 0) {
            // Pause for 5 seconds after completing a cycle
            setIsPaused(true);
          }
          return newIndex;
        });
      }, 150); // Change every 150 milliseconds

      return () => clearInterval(interval);
    } else {
      timeout = setTimeout(() => {
        setIsPaused(false); // Resume the animation after 5 seconds
      }, 3000); // 5-second pause

      return () => clearTimeout(timeout);
    }
  }, [isPaused, text.length]);

  return (
    <h2
      className="text-4xl lg:text-7xl md:text-6xl font-bold bg-clip-text bg-gradient-to-r from-blue-700 via-red-900 to-secondary mb-4 sm:text-5xl"
      data-aos="fade-up"
      data-aos-delay="600"
    >
      {text.split('').map((char, index) => (
        <span key={index} className={currentIndex === index && !isPaused ? 'shiny-letter' : ''}>
          {char}
        </span>
      ))}
    </h2>
  );
};

export default ShinyText;
